import { useEffect } from "react";

const ProductSchema = ({ product }) => {
  useEffect(() => {
    if (!product) return;

    const script = document.createElement("script");
    script.type = "application/ld+json";

    script.text = JSON.stringify({
      "@context": "https://schema.org/",
      "@type": "Product",
      "name": product.name,
      "image": [product.image],
      "description": product.shortDescription,
      "sku": product.id,
      "brand": {
        "@type": "Brand",
        "name": "Bastard Cards"
      },
      "offers": {
        "@type": "Offer",
        "url": `https://bastardcards.com/card/${product.id}`, // ← Replace with your actual domain
        "priceCurrency": "GBP",
        "price": product.price,
        "availability": "https://schema.org/InStock"
      }
    });

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [product]);

  return null;
};

export default ProductSchema;
